import React, { Component } from 'react';
import { loadModules } from 'esri-loader';
import { getMapExtent} from '../../esri/mapHub';
import symbols from '../../../defaults/Symbols.json'
import { configOperations } from '../../../redux/config';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export class MissingAcreageMap extends Component {
    constructor(props) {
        super(props);
        this.state =
        {
            mapIsLoaded: false
        };

        this.mapRef = React.createRef();
        this.startup();
    }

    componentWillReceiveProps(nextProps) {
        if (!this.state.mapIsLoaded && nextProps.open && !this.props.open) {
            this.startup();
        }

        if (nextProps.x !== null && nextProps.x !== this.props.x && nextProps.y !== null && nextProps.y !== this.props.y) {
            this.updatePoint(nextProps.x, nextProps.y);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    componentWillUnmount() {
        // Clean up jsapi's dirty little mess
    }

    render() {
        return (
            <div className="webmap" ref={this.mapRef}></div>
        );
    }

    updatePoint = (x, y) => {
        loadModules(['esri/geometry/coordinateFormatter', 'esri/Graphic', 'esri/symbols/SimpleMarkerSymbol'])
            .then(([coordinateFormatter, Graphic, SimpleMarkerSymbol]) => {
                coordinateFormatter.load().then(() => {
                    var newPoint = coordinateFormatter.fromLatitudeLongitude(y + " " + x);

                    this.originGraphicsLayer.removeAll();

                    this.originGraphicsLayer.graphics.add(
                        new Graphic(
                            {
                                geometry: newPoint,
                                symbol: new SimpleMarkerSymbol(symbols.newIncidentSymbol)
                            })
                    );

                    let options =
                    {
                        target: newPoint,
                        zoom: 14
                    }

                    this.view.goTo(options);
                    this.view.center = newPoint;
                });
            });
    }

    startup = () => {
        loadModules([
            'esri/Map',
            'esri/views/MapView',
            'esri/widgets/BasemapToggle',
            'esri/layers/GraphicsLayer',
            'esri/layers/FeatureLayer'], { css: true })
            .then(([
                ArcGISMap,
                MapView,
                BasemapToggle,
                GraphicsLayer,
                FeatureLayer]) => {
                const perimeterConfig = {
                    visible: true,
                    title: "NIFS Perimeters",   //TODO: Fix layername hardcode
                    //definitionExpression: "1=2",
                    outFields: ["*"],
                    renderer: {
                        type: "simple",  // autocasts as new SimpleRenderer()
                        symbol: symbols.selectedPerimeterSymbol
                    }
                };

                debugger;

                const fireHistoryConfig = {
                    portalItem: this.props.appConfig.fireHistoryLayer.jsInit[this.props.appConfig.env].portalItem,
                    visible: true,
                    title: "Fire History Perimeters",
                    opacity: 0.5,
                    outFields: ["IncidentName", "FeatureCategory", "MapMethod", "Comments", "GISAcres", "DeleteThis", "FeatureAccess", "FeatureStatus", "IRWINID", "Source"],
                    renderer: {
                        type: "simple",
                        symbol: symbols.selectedPerimeterSymbol
                    }
                };

                const finalFireConfig = {
                    portalItem: this.props.appConfig.finalFireFeatureLayer.jsInit[this.props.appConfig.env].portalItem,
                    visible: true,
                    title: "Final Fire Perimeters",
                    opacity: 0.5,
                    outFields: ["IncidentName", "FeatureCategory", "MapMethod", "GISAcres", "FeatureStatus", "IRWINID"],
                    renderer: {
                        type: "simple",
                        symbol: symbols.selectedPerimeterSymbol
                    }
                };

                const map = new ArcGISMap({
                    basemap: 'topo-vector'
                });

                this.view = new MapView({
                    container: this.mapRef.current,
                    map: map,
                    center: [-118, 34],
                    zoom: 8
                });

                this.basemapToggle = new BasemapToggle({
                    view: this.view
                });

                this.map = this.view.map;

                this.perimeterFeatureLayer = new FeatureLayer(Object.assign({}, perimeterConfig, this.props.appConfig.perimeterLayer.jsInit[this.props.appConfig.env]));
                this.perimeterFeatureLayer.listMode = "hide";

                this.fireHistoryLayer = new FeatureLayer(Object.assign({}, fireHistoryConfig, this.props.appConfig.fireHistoryLayer.jsInit[this.props.appConfig.env]));
                this.fireHistoryLayer.listMode = "show";
                this.fireHistoryLayer.popupTemplate = {
                    title: "{IncidentName}",
                    content: [
                        {
                            type: "fields",
                            fieldInfos: [
                                {
                                    fieldName: "IncidentName",
                                    label: "Incident Name"
                                },
                                {
                                    fieldName: "FeatureCategory",
                                    label: "Category"
                                },
                                {
                                    fieldName: "MapMethod",
                                    label: "Map Method"
                                },
                                {
                                    fieldName: "IRWINID",
                                    label: "IRWIN ID"
                                },
                                {
                                    fieldName: "GisAcres",
                                    label: "Acres"
                                },
                                {
                                    fieldName: "PolygonDateTime",
                                    label: "Polygon Date Time"
                                },
                                {
                                    fieldName: "FeatureStatus",
                                    label: "Feature Status"
                                },
                                {
                                    fieldName: "Collector",
                                    label: "Collector"
                                }
                            ]
                        }
                    ]
                };

                this.finalFireLayer = new FeatureLayer(Object.assign({}, finalFireConfig, this.props.appConfig.finalFireFeatureLayer.jsInit[this.props.appConfig.env]));
                this.finalFireLayer.listMode = "show";

                if (this.fireHistoryLayer) this.map.add(this.fireHistoryLayer);
                if (this.perimeterFeatureLayer) this.map.add(this.perimeterFeatureLayer);
                if (this.finalFireLayer) this.map.add(this.finalFireLayer);
                this.view.ui.add(this.basemapToggle, 'bottom-right');

                let originGraphicsLayer = new GraphicsLayer();
                map.add(originGraphicsLayer);
                this.originGraphicsLayer = originGraphicsLayer;

                //Set map extent to main map extent
                getMapExtent().then(
                    result => {
                        this.view.extent = result;
                    }
                );

                //Set map extent to main map extent
                /*getCurrentBasemap().then(
                 result =>
                   {
                    if (result.id !== this.view.map.basemap.id)
                    {
                      this.view.map.basemap = result.id;
                      this.basemapToggle.nextBasemap = (result.id === "satellite") ? 'topo-vector' : 'satellite';
                      //this.basemapToggle.activeBasemap = (result.id === "satellite") ? 'satellite' : 'topo-vector';
                    }
                   }
                 ); */

                //handler to move new incident graphic to user click point
                /*this.view.on("click", (event) => {
                    this.setState({
                        userLatitude: event.mapPoint.latitude,
                        userLongitude: event.mapPoint.longitude
                    });

                    this.props.onCoordinateUpdate(event.mapPoint.latitude, event.mapPoint.longitude);

                    this.originGraphicsLayer.removeAll();

                    this.originGraphicsLayer.graphics.add(
                        new Graphic(
                            {
                                geometry: event.mapPoint,
                                symbol: new SimpleMarkerSymbol(symbols.newIncidentSymbol)
                            })
                    );
                }); */

                this.setState({
                    mapIsLoaded: true
                });
            }

            );
    }
}

const mapStateToProps = state => ({
    appConfig: state.config
})

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        ...configOperations
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MissingAcreageMap)

